let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dj01M")).then(() => parcelRequire('9uPIH'));